import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { QR_LEVEL, qrValue } from './labelConstants';

interface LabelQRProps {
  // The shipment waybill the label is identified by.
  waybill: string;
  size?: number;
}

export const LabelQR: React.FC<LabelQRProps> = ({ waybill, size = 100 }) => (
  <QRCodeSVG
    value={qrValue(waybill)}
    size={size}
    level={QR_LEVEL}
    marginSize={0}
  />
);
